export default __webpack_public_path__ + "static/media/PageNotFound.31c09c1f.svg";